export function timeAgo(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} h ago`;
  const d = Math.floor(hr / 24);
  return `${d} d ago`;
}

export function waitingMinutes(iso) {
  return Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
}

export function formatReported(iso) {
  const d = new Date(iso);
  const date = d.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  return { date, time };
}

export function nowStamp() {
  const d = new Date();
  const date = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  return `${date} ${time}`;
}

export function clock() {
  return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
}

export const PRIORITY_RANK = { urgent: 3, warning: 2, normal: 1 };

export const STATUS_LABEL = {
  open: "Open",
  review: "Under Review",
  escalated: "Escalated",
  approved: "Approved",
  rejected: "Rejected",
};

export const PRIORITY_LABEL = {
  normal: "Normal",
  warning: "Warning",
  urgent: "Urgent",
};

// ---- SLA (review deadline) ----
export const SLA_HOURS = 24;

export function slaInfo(createdAtIso, status, hours = SLA_HOURS, closed) {
  const resolved = closed !== undefined ? closed : ["actioned", "rejected"].includes(status);
  const mins = Math.floor((Date.now() - new Date(createdAtIso).getTime()) / 60000);
  const slaMins = (hours || SLA_HOURS) * 60;
  const remaining = slaMins - mins;
  return {
    mins,
    resolved,
    remaining,
    overdue: !resolved && remaining < 0,
    dueSoon: !resolved && remaining >= 0 && remaining <= slaMins * 0.25,
  };
}

export function humanDuration(mins) {
  const m = Math.abs(Math.round(mins));
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  if (h < 24) return rm ? `${h}h ${rm}m` : `${h}h`;
  const d = Math.floor(h / 24);
  const rh = h % 24;
  return rh ? `${d}d ${rh}h` : `${d}d`;
}
